/**
 * The agency chooser (TZ §17.2). Shown once to a person who belongs to several agencies and has
 * not picked one yet. Nothing else of the product loads until they do: every request would be
 * refused without a named agency.
 */
import type { JSX } from "react";

import { useTranslation, type TranslationKey } from "@/i18n";
import { useAuthStore } from "@/store/auth";
import { Button } from "@/ui/button";

export function AgencyChooser(): JSX.Element {
  const { t } = useTranslation();
  const agencies = useAuthStore((state) => state.agencies);
  const switchAgency = useAuthStore((state) => state.switchAgency);

  return (
    <main className="flex min-h-dvh flex-col items-center justify-center bg-canvas px-4 py-10">
      <div className="flex w-full max-w-sm flex-col gap-6">
        <div className="flex flex-col gap-2">
          <h1 className="text-h2 font-semibold text-ink">{t("agency.choose.title")}</h1>
          <p className="text-sm text-ink-subtle">{t("agency.choose.hint")}</p>
        </div>
        <ul className="flex flex-col gap-2">
          {agencies.map((agency) => (
            <li key={agency.id}>
              <Button
                variant="secondary"
                className="w-full justify-between"
                onClick={(): void => {
                  switchAgency(agency.id);
                }}
              >
                <span>{agency.name}</span>
                <span className="text-sm text-ink-subtle">{t(`role.${agency.role}` as TranslationKey)}</span>
              </Button>
            </li>
          ))}
        </ul>
      </div>
    </main>
  );
}
